/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

const defaultProps = {
    ...commonDefaultProps,
    type: 'button',
};

const AdvertCloseButton = (props) => {
    const classNames = [
        'c-advert__close',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            type={props.componentClass === 'button' ? props.type : null}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

AdvertCloseButton.propTypes = propTypes;

AdvertCloseButton.defaultProps = defaultProps;

export default AdvertCloseButton;
